(() => {
  if (window.customModalInitialized) return;
  window.customModalInitialized = true;

  const selector = 'dialog.custom-modal';
  let activeDialog = null;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-custom-modal-open]');

    if (trigger) {
      const block = trigger.closest('[data-custom-modal]');
      const dialog = block?.querySelector(selector);

      if (!(dialog instanceof HTMLDialogElement)) return;

      event.preventDefault();

      if (dialog.open) return;

      if (activeDialog?.open) {
        activeDialog.close();
      }

      trigger.focus({ preventScroll: true });

      dialog.showModal();
      activeDialog = dialog;

      return;
    }

    const dialog = event.target.closest(`${selector}[open]`);

    if (!dialog) return;

    if (event.target.closest('[data-custom-modal-close]')) {
      event.preventDefault();
      dialog.close();
      return;
    }

    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();

      const clickedOutside =
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom;

      if (clickedOutside) {
        dialog.close();
      }
    }
  });

  window.addEventListener(
    'keydown',
    (event) => {
      if (!activeDialog?.isConnected || !activeDialog.open) return;
      if (event.key !== 'Escape' && event.key !== 'Tab') return;

      event.stopPropagation();

      if (event.key === 'Escape') {
        event.preventDefault();
        activeDialog.close();
      }
    },
    true
  );
})();